import React from "react";
import { getICMSList, createICMSTemplate, updateICMSTemplate } from "../../../../api/products";
import LoadingContainer from "../../../../_components/LoadingContainer";
import LoadingInput from "../../../../_components/LoadingInput";
import CurrencyInput from "react-currency-input"
import Button from "../../../../_components/Button";
import Modal from "../../../../_components/Modal";
import Text from "../../../../_components/Text";
import TableData from "../../../../_components/TableData";
import AppContext from "../../../AppViews/context";
import { CSOSN_DATA, ICMS_CST } from "./data"
import { showSnackBar } from "../../../../utils";

import DeleteICMS from "./DeleteICMS";

const deleteICMS = icmsId => {}

export default props => {
    const context = React.useContext(AppContext)

    const [loading, setLoading] = React.useState(false)
    const [data, setData] = React.useState([])
    const [icms, setICMS] = React.useState({})

    function onSave() {
        setTimeout(() => window.location.reload(), 1500)
    }
    function init() {
        setLoading(true)
        getICMSList()
            .then(resp => {
                resp = resp.map(icms => {
                    return {
                        ...icms,
                        id_dest_label: icms.id_dest === '2' ? '2=Interestadual': icms.id_dest === '3' ? '3=Exterior': '1=Interna',
                        ind_final_label: icms.ind_final === '1' ? '1=Consumidor final' : '0=Normal',
                        ind_ie_dest_label: icms.ind_ie_dest === '1' ? '1=Contribuinte': icms.ind_ie_dest === '2' ? '2=Isento': '9=Não contribuinte',
                        "orig": icms.orig == 0 ? "0= Nacional" :
                                icms.orig == 1 ? "1= Estrangeira" :
                                icms.orig == 2 ? "2= Estrangeira - Adquirida no mercado interno, exceto a indicada no código 7":
                                icms.orig == 3 ? "3= Nacional, mercadoria ou bem com Conteúdo de Importação superior a 40% (quarenta por cento) e inferior ou igual a 70% (setenta por cento)":
                                icms.orig == 5 ? "5= Nacional, mercadoria ou bem com Conteúdo de Importação inferior ou igual a 40% (quarenta por cento)":
                                icms.orig == 6 ? "6= Estrangeira, importação direta, sem similar nacional, constante em lista de resolução do conselho de ministros":
                                icms.orig == 7 ? "7= Estrangeira, adquirida no mercado interno, sem similar nacional, constante em lista de resolução da CAMEX":
                                icms.orig == 8 ? "8= Nacional, mercadoria ou bem com Conteúdo de Importação superior a 70%" : "",
                        "edit": <div className="d-flex gap-2" >
                            <Button onClick={() => setICMS(icms)} as="text"><i className="fas fa-edit"></i></Button>
                            <DeleteICMS id={icms.id} title={icms.name} />
                        </div>
                    }
                })
                setData(resp)
            })
            .finally(() => {
                setLoading(false)
            })
    }
    React.useEffect(init, [])
    const isCST = context.currentBranch.crt == 2 || context.currentBranch.crt == 3;
    const key = isCST ? "CST" : "CSOSN"
    const value = isCST ? "cst" : "csosn"
    return <div className="container-fluid">
        <div className="row">
            <div className="col-12 py-3">
                <Text className="text-center" as="h1">
                    Modelos de ICMS
                </Text>
                <div className="d-flex justify-content-center my-3">
                    <Template
                        showDisclaimer={data.length === 0}
                        onSave={onSave}
                        data={icms} />
                </div>
                {
                    data.length > 0
                        ? <LoadingContainer loading={loading}>
                            <TableData
                                data={data}
                                tHead={["Nome", "Origem da Mercadoria", key, "Alíquota (%)", "Ações"]}
                                tBodyKeys={["name", "orig", value, "p_icms", "edit", ]}
                            />
                        </LoadingContainer>
                        : <React.Fragment />
                }
            </div>
        </div>
    </div>
}

export function Template(props) {
    const context = React.useContext(AppContext)

    const [show, setShow] = React.useState(false)
    const [loading, setLoading] = React.useState(false)
    const [cst, setCST] = React.useState([])
    const [template, setTemplateData] = React.useState({})
    const isCST = context.currentBranch.crt == 2 || context.currentBranch.crt == 3;
    const key = isCST ? "CST" : "CSOSN"
    const value = isCST ? "cst" : "csosn"

    function onChange({ target }) {
        const { name: key, value } = target
        let newTemplate = { ...template, [key]: value }

        if (key === 'cst' || key === 'csosn') {
            if (!["20", "30", "40", "41", "50", "70", "90", "900"].includes(String(value))) {
                newTemplate.v_icms_deson = null;
                newTemplate.mot_des_icms = null;
            }
        }

        setTemplateData(newTemplate)
    }
    function onHide() {
        setTemplateData({})
        setShow(false)
    }
    function onSubmit() {

        if (!template.name && !template.orig && !template.csosn) {
            return
        }

        if (template.orig === undefined) {
            showSnackBar("Selecione a origem da mercadoria")
            try { document.querySelector('[name="orig"]').focus() } catch (error) { }
            return
        }
        if (!template[value] === undefined) {
            showSnackBar(`Selecione o ${key}`)
            try { document.querySelector(`[name="${value}"]`).focus() } catch (error) { }
            return
        }

        if (!isCST && template.csosn === undefined ||
            !isCST && template.csosn == '' ||
            isCST && template.cst == undefined ||
            isCST && template.cst == ''

        ) {
            showSnackBar(`Selecione um ${isCST ? 'cst' : 'csosn'} válido`)
            try { document.querySelector('[name="csosn"]').focus() } catch (error) { }
            return
        }


        const request = template.id ? updateICMSTemplate : createICMSTemplate

        setLoading(true)

        request(template)
            .then(icms => {
                showSnackBar("ICMS Salvo", "info")
                if (!props.onSave) {
                    setTimeout(() => window.location.reload(), 1500)
                } else {
                    props.onSave(icms)
                }
            })
            .finally(() => {
                setTimeout(() => {
                    setLoading(false)
                    if (props.onClear) {
                        setShow(false)
                        setTemplateData({})
                    }
                }, 2000)
            })
    }
    function automate() {
        setTemplateData({
            name: "SIMPLES NACIONAL",
            orig: "0",
            csosn: "102",
            id_dest: "2",      //interestadual
            ind_final: "1",    //consumidor final
            ind_ie_dest: "9"   //nao contribuinte
        })
    }
    function edit() {
        if (props.data.id) {
            setTemplateData({
                ...props.data,
                p_icms: props.data.p_icms || 0,
                p_icms_inter: props.data.p_icms_inter || 0,
                id_dest: props.data.id_dest !== undefined ? String(props.data.id_dest) : '',
                ind_final: props.data.ind_final !== undefined ? String(props.data.ind_final) : '',
                ind_ie_dest: props.data.ind_ie_dest !== undefined ? String(props.data.ind_ie_dest) : ''
            })
            setShow(true)
        }
    }

    React.useEffect(edit, [props.data])
    function init() {
        const isCST = context.currentBranch.crt == 2 || context.currentBranch.crt == 3;
        setCST(isCST ? ICMS_CST : CSOSN_DATA)
    }
    React.useEffect(init, [])
    return <div>
        <Button
            as="text"
            onClick={() => setShow(true)} >
            Criar novo modelo
        </Button>
        <Modal show={show} title="Cadastrar modelo de ICMS" onHide={onHide}>
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        {
                            props.showDisclaimer
                                ?
                                <div className="py-3">
                                    <Text>
                                        Clique <Button onClick={automate} as="text">aqui</Button> criar a configuração padrão de ICMS
                                    </Text>
                                    <Text>
                                        Importante: esse tipo de configuração padrão deve ser consultado e confirmado, de preferência, pela contabilidade da sua empresa.
                                    </Text>
                                </div>
                                : <React.Fragment />
                        }
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <div className="form-label">
                                <Text>
                                    Nome/descrição do modelo
                                </Text>
                            </div>
                            <LoadingInput
                                loading={loading}
                                required
                                name="name"
                                onChange={onChange}
                                value={template.name} />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <div className="form-label">
                                <Text>
                                    Origem da mercadoria
                                </Text>
                            </div>
                            <LoadingInput
                                loading={loading}
                                name="orig"
                                required
                                onChange={onChange}
                                as="select">
                                <option selected disabled>
                                    Selecione a origem
                                </option>
                                <option selected={template.orig == '0'} value="0">0= Nacional</option>
                                <option selected={template.orig == '1'} value="1">1= Estrangeira</option>
                                <option selected={template.orig == '2'} value="2">2= Estrangeira - Adquirida no mercado interno, exceto a indicada no código 7</option>
                                <option selected={template.orig == '3'} value="3">3= Nacional, mercadoria ou bem com Conteúdo de Importação superior a 40% (quarenta por cento) e inferior ou igual a 70% (setenta por cento)</option>
                                <option selected={template.orig == '4'} value="4">4= Nacional, cuja produção tenha sido feita em conformidade com os processos produtivos básicos (PPB) de que tratam o Decreto-Lei nº 288/1967, e as Leis nºs 8.248/1991, 8.387/1991, 10.176/2001 e 11.484/2007.</option>
                                <option selected={template.orig == '5'} value="5">5= Nacional, mercadoria ou bem com Conteúdo de Importação inferior ou igual a 40% (quarenta por cento)</option>
                                <option selected={template.orig == '6'} value="6">6= Estrangeira, importação direta, sem similar nacional, constante em lista de resolução do conselho de ministros</option>
                                <option selected={template.orig == '7'} value="7">7= Estrangeira, adquirida no mercado interno, sem similar nacional, constante em lista de resolução da CAMEX</option>
                                <option selected={template.orig == '8'} value="8">8= Nacional, mercadoria ou bem com Conteúdo de Importação superior a 70%</option>
                            </LoadingInput>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <div className="form-label">
                                <Text>
                                    Selecione o {isCST ? "CST" : "CSOSN"}
                                </Text>
                            </div>
                            <LoadingInput
                                loading={loading}
                                name={isCST ? "cst" : "csosn"}
                                onChange={onChange}
                                as="select">
                                <option>
                                    Selecione o {isCST ? "CST" : "CSOSN"}
                                </option>
                                {
                                    (isCST ? ICMS_CST : CSOSN_DATA).map((item, idx) => {
                                        return <option
                                            selected={template[value] == item.value}
                                            key={`icms-list-${item.value}${idx}`}
                                            value={item.value}>{item.label}</option>
                                    })
                                }
                            </LoadingInput>
                        </div>
                    </div>

                    {isCST && (
                        <React.Fragment>
                            <div className="col-md-4">
                                <div className="form-group">
                                    <div className="form-label"><Text>Destino da Operação</Text></div>
                                    <LoadingInput
                                        loading={loading}
                                        name="id_dest"
                                        onChange={onChange}
                                        as="select"
                                        value={template.id_dest || ''}
                                    >
                                        <option value="" disabled>Selecione</option>
                                        <option value="1">1 = Interna</option>
                                        <option value="2">2 = Interestadual</option>
                                        <option value="3">3 = Exterior</option>
                                    </LoadingInput>
                                </div>
                            </div>

                            <div className="col-md-4">
                                <div className="form-group">
                                    <div className="form-label"><Text>Consumidor Final</Text></div>
                                    <LoadingInput
                                        loading={loading}
                                        name="ind_final"
                                        onChange={onChange}
                                        as="select"
                                        value={template.ind_final || ''}
                                    >
                                        <option value="" disabled>Selecione</option>
                                        <option value="0">0 = Não</option>
                                        <option value="1">1 = Sim</option>
                                    </LoadingInput>
                                </div>
                            </div>

                            <div className="col-md-4">
                                <div className="form-group">
                                    <div className="form-label"><Text>IE do Destinatário</Text></div>
                                    <LoadingInput
                                        loading={loading}
                                        name="ind_ie_dest"
                                        onChange={onChange}
                                        as="select"
                                        value={template.ind_ie_dest || ''}
                                    >
                                        <option value="" disabled>Selecione</option>
                                        <option value="1">1 = Contribuinte</option>
                                        <option value="2">2 = Contribuinte Isento</option>
                                        <option value="9">9 = Não Contribuinte</option>
                                    </LoadingInput>
                                </div>
                            </div>
                        </React.Fragment>
                    )}


                    <div className="col-md-4">
                        <div className="form-group">
                            <div className="form-label">
                                <Text>
                                    Alíquota do ICMS
                                </Text>
                            </div>
                            <CurrencyInput
                                disabled={loading}
                                required={true}
                                name="p_icms"
                                value={template.p_icms}
                                onChange={(e, value, b) => onChange({ target: { name: "p_icms", value } })}
                                suffix=" %"
                                className="form-control" />
                        </div>
                    </div>
                    {["20", "30", "40", "41", "50", "70", "90", "900"].includes(String(template[value])) && (
                        <React.Fragment>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <div className="form-label">
                                        <Text>Valor do ICMS Desonerado</Text>
                                    </div>
                                    <CurrencyInput
                                        disabled={loading}
                                        name="v_icms_deson"
                                        value={template.v_icms_deson}
                                        prefix="R$ "
                                        decimalSeparator=","
                                        thousandSeparator="."
                                        onChange={(a, value, c) =>
                                            onChange({ target: { name: "v_icms_deson", value } })
                                        }
                                        className="form-control"
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <div className="form-label">
                                        <Text>Motivo da Desoneração do ICMS</Text>
                                    </div>
                                    <LoadingInput
                                        loading={loading}
                                        name="mot_des_icms"
                                        onChange={onChange}
                                        as="select"
                                        value={template.mot_des_icms || ""}
                                    >
                                        <option value="">Selecione o motivo</option>
                                        <option value="1">1 - Táxi</option>
                                        <option value="3">3 - Produtor Agropecuário</option>
                                        <option value="4">4 - Frotista/Locadora</option>
                                        <option value="5">5 - Diplomático/Consular</option>
                                        <option value="6">6 - Utilitários e Motocicletas da Amazônia Ocidental e ALC</option>
                                        <option value="7">7 - SUFRAMA</option>
                                        <option value="8">8 - Venda a órgão Público</option>
                                        <option value="9">9 - Outros</option>
                                        <option value="10">10 - Deficiente Condutor</option>
                                        <option value="11">11 - Deficiente não Condutor</option>
                                        <option value="12">12 - Órgão de Fomento e Desenvolvimento Agropecuário</option>
                                        <option value="16">16 - Olimpíadas Rio 2016</option>
                                    </LoadingInput>
                                </div>
                            </div>
                        </React.Fragment>
                    )}

                    {context.currentBranch.crt == 3 && (
                        <div className="col-md-4">
                            <div className="form-group">
                                <div className="form-label">
                                    <Text>
                                        Alíquota Interestadual
                                    </Text>
                                </div>
                                <CurrencyInput
                                    disabled={loading}
                                    name="p_icms_inter"
                                    value={template.p_icms_inter}
                                    onChange={(e, value, b) => onChange({ target: { name: "p_icms_inter", value } })}
                                    suffix=" %"
                                    className="form-control" />
                            </div>
                        </div>
                    )}
                </div>
                <div className="row">
                    <div className="col-12">
                        <div className="d-flex justify-content-start">
                            <Button
                                id="create-icms-template-ijkl-xpto"
                                onClick={onSubmit}
                                as="text"
                                disabled={loading} >
                                Salvar modelo de ICMS
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    </div>

}



// WEBPACK FOOTER //
// ./src/views/Fiscal/Taxes/ICMS/index.jsx